export enum SkillRatingType {
  SKILL = 'SKILL',
  COMPETENCY = 'COMPETENCY'
}